import { gql } from "@apollo/client"
import { COACH_TOOLS_API } from "../apolloClient"
import { getMembershipMobileEducationPurchaseUrl } from "./educationPgmPurchase"

export const EDUCATION_CPP_OFFERING_QUERY = gql`
  query EducationCppOffering {
    me {
      id
      educationCppOffering {
        id
      }
    }
  }
`

export const CPP_PURCHASE_UNAVAILABLE_MESSAGE =
  "Enrollment in the Certified Professional Program isn't available right now. Please call PGA Education at (866) 866-3382, option 6."

const reportCppPurchaseUnavailable = error => {
  window.rg4js &&
    window.rg4js("send", { error, tags: ["education-cpp-purchase"] })
}

export const redirectToEducationCppPurchase = async ({ client }) => {
  try {
    const { data } = await client.query({
      query: EDUCATION_CPP_OFFERING_QUERY,
      context: { api: COACH_TOOLS_API },
      fetchPolicy: "network-only",
    })
    const url = getMembershipMobileEducationPurchaseUrl(
      data?.me?.educationCppOffering?.id,
    )
    if (!url) {
      reportCppPurchaseUnavailable(
        new Error("No CPP purchase offering for an approved member"),
      )
      return false
    }

    window.location.assign(url)
    return true
  } catch (error) {
    reportCppPurchaseUnavailable(error)
    return false
  }
}
